module.exports = __webpack_public_path__ + "imgascvts/logo_2024.68636108.png";